import { createFileRoute } from "@tanstack/react-router";
import { useParams } from "@tanstack/react-router";

import { MainLayout } from "@/components/layouts/main-layout";
import { InvoiceReviewPanel } from "@/components/shared/invoice-review/invoice-review-panel";
import { useInvoiceReviewContext } from "@/features/invoice-standard-review/accounting/ReviewProvider";
import { InvoiceReviewClient as _InvoiceReviewClient } from "@/features/invoice-standard-review/client";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_focused/rechnung/$id/",
)({
  component: InvoiceReview,
});

function InvoiceReviewClient({ invoiceId }: { invoiceId: string }) {
  const { updateBox } = useInvoiceReviewContext();

  return (
    <_InvoiceReviewClient
      key={invoiceId}
      invoiceId={invoiceId}
      updateBox={updateBox}
    />
  );
}

function InvoiceReview() {
  const { id: invoiceId } = useParams({ from: Route.id });

  return (
    <InvoiceReviewPanel
      invoiceId={invoiceId}
      invoiceViewerPanel={{ defaultSize: 35, maxSize: 65 }}
      invoiceReviewPanel={{
        maxSize: 45,
        defaultSize: 35,
        component: InvoiceReviewClient,
      }}
    />
  );
}
